import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function NewTaskDialog({ open, onOpenChange, defaultClientId, onCreated }) {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({
    title: "",
    client_id: defaultClientId || "",
    due_date: "",
    priority: "orta",
    status: "acik",
  });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/clients").then((r) => setClients(r.data));
    setForm((prev) => ({ ...prev, client_id: defaultClientId || prev.client_id }));
    // eslint-disable-next-line
  }, [open, defaultClientId]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { ...form };
      if (payload.due_date) payload.due_date = new Date(payload.due_date).toISOString();
      if (!payload.client_id) delete payload.client_id;
      const { data } = await api.post("/tasks", payload);
      toast.success("Görev eklendi");
      onCreated && onCreated(data);
      onOpenChange(false);
      setForm({ title: "", client_id: defaultClientId || "", due_date: "", priority: "orta", status: "acik" });
    } catch (e2) {
      toast.error(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="new-task-dialog">
        <DialogHeader>
          <DialogTitle>Yeni Görev</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Başlık *</label>
            <input
              required
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              data-testid="new-task-title"
              className="w-full h-9 px-3 border border-pleiades-border rounded-sm text-[13px] focus:outline-none focus:border-pleiades-blue"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Danışan</label>
              <select
                value={form.client_id}
                onChange={(e) => setForm({ ...form, client_id: e.target.value })}
                data-testid="new-task-client"
                className="w-full h-9 px-2 border border-pleiades-border rounded-sm text-[13px] bg-white"
              >
                <option value="">— Yok —</option>
                {clients.map((c) => (
                  <option key={c.id} value={c.id}>{c.full_name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Öncelik</label>
              <select
                value={form.priority}
                onChange={(e) => setForm({ ...form, priority: e.target.value })}
                data-testid="new-task-priority"
                className="w-full h-9 px-2 border border-pleiades-border rounded-sm text-[13px] bg-white"
              >
                <option value="dusuk">Düşük</option>
                <option value="orta">Orta</option>
                <option value="yuksek">Yüksek</option>
              </select>
            </div>
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Vade</label>
            <input
              type="datetime-local"
              value={form.due_date}
              onChange={(e) => setForm({ ...form, due_date: e.target.value })}
              data-testid="new-task-due"
              className="w-full h-9 px-3 border border-pleiades-border rounded-sm text-[13px]"
            />
          </div>
          <DialogFooter className="pt-2">
            <button type="button" onClick={() => onOpenChange(false)} className="h-9 px-3 border border-pleiades-border rounded-sm text-[13px] hover:bg-pleiades-sidebar">
              Vazgeç
            </button>
            <button type="submit" disabled={busy} data-testid="new-task-submit" className="h-9 px-3 bg-pleiades-blue hover:bg-pleiades-blue-hover text-white text-[13px] rounded-sm disabled:opacity-50">
              {busy ? "Kaydediliyor…" : "Görev Ekle"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
